export default {
  'pages.layouts.userLayout.title':
    'Ant Design is the most influential web design specification in Xihu district',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.login.welcome': 'Welcome to Intelligent Video Processing Platform',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.noauth.createTitle': 'Create No Auth Interface',
  'pages.noauth.editTitle': 'Edit No Auth Interface',
  'pages.noauth.updatedSuccessfully': 'Updated Successfully',
  'pages.noauth.createdSuccessfully': 'Created Successfully',
  'pages.noauth.updateFailed': 'Update Failed, Please Try Again',
  'pages.noauth.createFailed': 'Create Failed, Please Try Again',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.role.createTitle': 'Create Role',
  'pages.role.editTitle': 'Edit Role',
  'pages.role.updatedSuccessfully': 'Updated Successfully',
  'pages.role.createdSuccessfully': 'Created Successfully',
  'pages.role.updateFailed': 'Update Failed, Please Try Again',
  'pages.role.createFailed': 'Create Failed, Please Try Again',
  'pages.role.detailTitle': 'Role Details',
  'pages.role.name': 'Role Name',
  'pages.role.orgName': 'Organization Name',
  'pages.role.roleType': 'Role Type',
  'pages.role.orgType': 'Organization Type',
  'pages.role.management': 'Role Management',
  'pages.role.new': 'New Role',
  'pages.role.name.required': 'Role name is required',
  'pages.role.name.placeholder': 'Please enter role name',
  'pages.role.orgName.required': 'Organization name is required',
  'pages.role.orgName.placeholder': 'Please enter organization name',
  'pages.role.roleType.placeholder': 'Please enter role type',
  'pages.role.remark': 'Remark',
  'pages.role.remark.placeholder': 'Please enter remark',
  'pages.role.createdAt': 'Created At',
  'pages.role.updatedAt': 'Updated At',
  'pages.role.detail': 'Details',
  'pages.role.edit': 'Edit',
  'pages.role.delete': 'Delete',
  'pages.role.deleteConfirm': 'Are you sure you want to delete this item?',
  'pages.role.okText': 'OK',
  'pages.role.cancelText': 'Cancel',
  'pages.orgdept.name': 'Department Name',
  'pages.orgdept.name.required': 'Department name is required',
  'pages.orgdept.name.placeholder': 'Please enter department name',
  'pages.orgdept.parentId': 'Parent Department ID',
  'pages.orgdept.parentId.placeholder': 'Please enter parent department ID',
  'pages.orgdept.orgId': 'Organization ID',
  'pages.orgdept.orgId.placeholder': 'Please enter organization ID',
  'pages.orgdept.remark': 'Remark',
  'pages.orgdept.remark.placeholder': 'Please enter remark',
  'pages.orgdept.detailTitle': 'Department Detail',
  'pages.orgdept.createTitle': 'Create Department',
  'pages.orgdept.editTitle': 'Edit Department',
  'pages.orgdept.updatedSuccessfully': 'Updated Successfully',
  'pages.orgdept.createdSuccessfully': 'Created Successfully',
  'pages.orgdept.updateFailed': 'Update Failed, Please Try Again',
  'pages.orgdept.createFailed': 'Create Failed, Please Try Again',
  'pages.orgdept.orgName': 'Organization Name',
  'pages.orgdept.createdAt': 'Created At',
  'pages.orgdept.updatedAt': 'Updated At',
  'pages.orgpost.name': 'Post Name',
  'pages.orgpost.name.required': 'Post name is required',
  'pages.orgpost.name.placeholder': 'Please enter post name',
  'pages.orgpost.orgId': 'Organization ID',
  'pages.orgpost.orgId.placeholder': 'Please enter organization ID',
  'pages.orgpost.desc': 'Post Description',
  'pages.orgpost.desc.placeholder': 'Please enter post description',
  'pages.orgpost.detailTitle': 'Post Detail',
  'pages.orgpost.createTitle': 'Create Post',
  'pages.orgpost.editTitle': 'Edit Post',
  'pages.orgpost.updatedSuccessfully': 'Updated Successfully',
  'pages.orgpost.createdSuccessfully': 'Created Successfully',
  'pages.orgpost.updateFailed': 'Update Failed, Please Try Again',
  'pages.orgpost.createFailed': 'Create Failed, Please Try Again',
  'pages.orgpost.orgName': 'Organization Name',
  'pages.orgpost.orgId.required': 'Organization ID is required',
  'pages.orgpost.createdAt': 'Created At',
  'pages.orgpost.updatedAt': 'Updated At',
  'pages.orgdept.management': 'Department Management',
  'pages.orgdept.new': 'New',
  'pages.orgtree.management': 'Organization Structure',
  'pages.orgtree.new': 'New Organization',
  'pages.orgtree.addChild': 'Add Child Organization',
  'pages.orgtree.edit': 'Edit Organization',
  'pages.orgtree.detail': 'Organization Details',
  'pages.orgtree.delete': 'Delete Organization',
  'pages.orgtree.manageDepts': 'Department Management',
  'pages.orgtree.managePosts': 'Position Management',
  'pages.orgtree.manageEmployees': 'Employee Management',
  'pages.orgtree.deleteConfirm':
    'Are you sure you want to delete this organization?',
  'pages.orgtree.createTitle': 'Create Organization',
  'pages.orgtree.editTitle': 'Edit Organization',
  'pages.orgtree.detailTitle': 'Organization Details',
  'pages.orgtree.updatedSuccessfully': 'Organization updated successfully',
  'pages.orgtree.createdSuccessfully': 'Organization created successfully',
  'pages.orgtree.updateFailed': 'Organization update failed, please try again',
  'pages.orgtree.createFailed':
    'Organization creation failed, please try again',
  'pages.orgtree.deleteSuccess': 'Organization deleted successfully',
  'pages.orgtree.deleteFailed': 'Organization deletion failed',
  'pages.orgtree.fetchDetailFailed': 'Failed to fetch organization details',
  'pages.orgtree.name': 'Organization Name',
  'pages.orgtree.name.required': 'Organization name is required',
  'pages.orgtree.name.placeholder': 'Please enter organization name',
  'pages.orgtree.code': 'Organization Code',
  'pages.orgtree.code.required': 'Organization code is required',
  'pages.orgtree.code.placeholder': 'Please enter organization code',
  'pages.orgtree.type': 'Organization Type',
  'pages.orgtree.type.placeholder': 'Please select organization type',
  'pages.orgtree.contact': 'Contact Person',
  'pages.orgtree.contact.placeholder': 'Please enter contact person',
  'pages.orgtree.phone': 'Contact Phone',
  'pages.orgtree.phone.placeholder': 'Please enter contact phone',
  'pages.orgtree.email': 'Email',
  'pages.orgtree.email.placeholder': 'Please enter email',
  'pages.orgtree.address': 'Address',
  'pages.orgtree.address.placeholder': 'Please enter address',
  'pages.orgtree.sort': 'Sort Order',
  'pages.orgtree.sort.placeholder': 'Please enter sort order',
  'pages.orgtree.orgTyp': 'Organization Type',
  'pages.orgtree.orgTyp.placeholder': 'Please select organization type',
  'pages.orgtree.orgTyp.company': 'Company',
  'pages.orgtree.orgTyp.department': 'Department',
  'pages.orgtree.orgTyp.group': 'Group',
  'pages.orgtree.orgTyp.branch': 'Branch',
  'pages.orgtree.uscc': 'Unified Social Credit Code',
  'pages.orgtree.uscc.placeholder': 'Please enter unified social credit code',
  'pages.orgtree.enabled': 'Status',
  'pages.orgtree.remark': 'Remark',
  'pages.orgtree.remark.placeholder': 'Please enter remark',
  'pages.orgtree.parentId': 'Parent Organization',
  'pages.orgtree.parentId.placeholder':
    'Please select parent organization, leave blank for top level',
  'pages.orgtree.createdAt': 'Created At',
  'pages.orgtree.updatedAt': 'Updated At',
  'pages.orgtree.refresh': 'Refresh',
  'pages.orgpost.management': 'Post Management',
  'pages.orgpost.new': 'New',
  'pages.orgdept.detail': 'Details',
  'pages.orgdept.edit': 'Edit',
  'pages.orgdept.delete': 'Delete',
  'pages.orgdept.deleteConfirm': 'Are you sure you want to delete this item?',
  'pages.orgdept.okText': 'OK',
  'pages.orgdept.cancelText': 'Cancel',
  'pages.orgdept.fetchDetailFailed': 'Failed to fetch details',
  'pages.orgdept.deleteSuccess': 'Successfully deleted',
  'pages.orgdept.deleteFailed': 'Failed to delete',
  'pages.orgpost.detail': 'Details',
  'pages.orgpost.edit': 'Edit',
  'pages.orgpost.delete': 'Delete',
  'pages.orgpost.deleteConfirm': 'Are you sure you want to delete this item?',
  'pages.orgpost.okText': 'OK',
  'pages.orgpost.cancelText': 'Cancel',
  'pages.orgpost.fetchDetailFailed': 'Failed to fetch details',
  'pages.orgpost.deleteSuccess': 'Successfully deleted',
  'pages.orgpost.deleteFailed': 'Failed to delete',
  'pages.role.deleteSuccess': 'Successfully deleted',
  'pages.role.deleteFailed': 'Failed to delete',
  'pages.role.fetchDetailFailed': 'Failed to fetch details',
  'pages.employee.management': 'Employee Management',
  'pages.employee.new': 'New Employee',
  'pages.employee.detail': 'Details',
  'pages.employee.edit': 'Edit',
  'pages.employee.delete': 'Delete',
  'pages.employee.deleteConfirm': 'Are you sure you want to delete this item?',
  'pages.employee.okText': 'OK',
  'pages.employee.cancelText': 'Cancel',
  'pages.employee.deleteSuccess': 'Successfully deleted',
  'pages.employee.deleteFailed': 'Failed to delete',
  'pages.employee.fetchDetailFailed': 'Failed to fetch details',
  'pages.employee.createTitle': 'Create Employee',
  'pages.employee.editTitle': 'Edit Employee',
  'pages.employee.detailTitle': 'Employee Details',
  'pages.employee.updatedSuccessfully': 'Updated Successfully',
  'pages.employee.createdSuccessfully': 'Created Successfully',
  'pages.employee.updateFailed': 'Update Failed, Please Try Again',
  'pages.employee.createFailed': 'Create Failed, Please Try Again',
  'pages.employee.employeeNumber': 'Employee Number',
  'pages.employee.name': 'Name',
  'pages.employee.organization': 'Organization',
  'pages.employee.department': 'Department',
  'pages.employee.position': 'Position',
  'pages.employee.role': 'Role',
  'pages.employee.status': 'Status',
  'pages.employee.active': 'Active',
  'pages.employee.inactive': 'Inactive',
  'pages.employee.remark': 'Remark',
  'pages.employee.namePlaceholder': 'Please enter name!',
  'pages.employee.employeeId': 'Employee ID',
  'pages.employee.employeeIdPlaceholder': 'Please enter employee ID',
  'pages.employee.selectDepartment': 'Please select department',
  'pages.employee.selectPosition': 'Please select position',
  'pages.employee.operation': 'Operation',
  'pages.employee.deleteConfirmContent':
    'Are you sure you want to delete this employee?',

  // Device Management Module Internationalization
  'pages.device.management': 'Device Management',
  'pages.device.gateway': 'Gateway',
  'pages.device.terminal': 'Terminal',
  'pages.device.noData': 'No device data',
  'pages.device.noDataDescription':
    'There is currently no device data, please create a gateway device first',
  'pages.device.createGateway': 'Create Gateway',
  'pages.device.refresh': 'Refresh',
  'pages.device.viewDetails': 'View Details',
  'pages.device.online': 'Online',
  'pages.device.offline': 'Offline',
  'pages.device.hasChild': 'Has child devices',
  'pages.device.noChild': 'No child devices',

  // Event Management Module General Internationalization
  'pages.event.management': 'Event Management',
  'pages.event.record': 'Event Record',
  'pages.event.order': 'Event Order',
  'pages.event.node': 'Order Node',
  'pages.event.receiver': 'Event Receiver',
  'pages.event.resource': 'Resource File',
  'pages.event.create': 'Create',
  'pages.event.edit': 'Edit',
  'pages.event.delete': 'Delete',
  'pages.event.view': 'View',
  'pages.event.refresh': 'Refresh',
  'pages.event.search': 'Search',
  'pages.event.confirmDelete': 'Confirm Delete',
  'pages.event.deleteSuccess': 'Delete Success',
  'pages.event.deleteFailed': 'Delete Failed',
  'pages.event.createSuccess': 'Create Success',
  'pages.event.updateSuccess': 'Update Success',
  'pages.event.operation': 'Operation',

  // Event Receiver Module Internationalization
  'pages.eventReceiver.management': 'Event Receiver Management',
  'pages.eventReceiver.name': 'Receiver Name',
  'pages.eventReceiver.type': 'Receiver Type',
  'pages.eventReceiver.endpoint': 'Endpoint Address',
  'pages.eventReceiver.description': 'Description',
  'pages.eventReceiver.status': 'Status',
  'pages.eventReceiver.createTitle': 'Create Event Receiver',
  'pages.eventReceiver.editTitle': 'Edit Event Receiver',
  'pages.eventReceiver.viewTitle': 'View Event Receiver',
  'pages.eventReceiver.namePlaceholder': 'Please enter receiver name',
  'pages.eventReceiver.typePlaceholder': 'Please select receiver type',
  'pages.eventReceiver.endpointPlaceholder': 'Please enter endpoint address',
  'pages.eventReceiver.descriptionPlaceholder': 'Please enter description',
  'pages.eventReceiver.email': 'Email',
  'pages.eventReceiver.webhook': 'Webhook',
  'pages.eventReceiver.sms': 'SMS',
  'pages.eventReceiver.mqtt': 'MQTT',
  'pages.eventReceiver.enabled': 'Enabled',
  'pages.eventReceiver.disabled': 'Disabled',
  'pages.eventReceiver.deleteConfirm':
    'Are you sure you want to delete this event receiver?',

  // Resource File Module Internationalization
  'pages.resourceFile.management': 'Resource File Management',
  'pages.resourceFile.name': 'File Name',
  'pages.resourceFile.type': 'File Type',
  'pages.resourceFile.size': 'File Size',
  'pages.resourceFile.path': 'File Path',
  'pages.resourceFile.description': 'Description',
  'pages.resourceFile.tags': 'Tags',
  'pages.resourceFile.status': 'Status',
  'pages.resourceFile.uploadTime': 'Upload Time',
  'pages.resourceFile.uploader': 'Uploader',
  'pages.resourceFile.createTitle': 'Create Resource File',
  'pages.resourceFile.editTitle': 'Edit Resource File',
  'pages.resourceFile.viewTitle': 'View Resource File',
  'pages.resourceFile.namePlaceholder': 'Please enter file name',
  'pages.resourceFile.typePlaceholder': 'Please select file type',
  'pages.resourceFile.descriptionPlaceholder': 'Please enter file description',
  'pages.resourceFile.tagsPlaceholder':
    'Please enter tags, press Enter to confirm',
  'pages.resourceFile.uploadPlaceholder': 'Click to upload file',
  'pages.resourceFile.fileRequired': 'Please select a file to upload',
  'pages.resourceFile.fileSizeLimit': 'File size cannot exceed 100MB',
  'pages.resourceFile.download': 'Download',
  'pages.resourceFile.preview': 'Preview',
};
